import React from 'react'
import logUtil from 'utils/log'
import Flex from 'components/Flex'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import Link from 'components/Link'
import { ROUTE_PATH } from 'modules/route/constants'
import Image from 'components/Image'
import H3 from 'components/H3'
import './index.css'
import Section from 'components/Section'

const TITLE = 'You haven’t rated any samples yet'
const RATE_YOUR_SAMPLES = 'Rate your samples'
const SHOP_SAMPLES = 'Shop samples'
const IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0569/9957/5718/files/Frame_15156.png?v=1695773014'
const ANALYTICS_EVENT = {
  SQUAD_EMPTY_RATE_YOUR_SAMPLES: 'SQUAD_EMPTY_RATE_YOUR_SAMPLES',
  SQUAD_EMPTY_SHOP_SAMPLES: 'SQUAD_EMPTY_SHOP_SAMPLES'
}

export default function SquadPageYouVeRatedSamplesAcrossOrdersEmpty () {
  const debugProps = {}
  logUtil('SquadPageYouVeRatedSamplesAcrossOrdersEmpty').debug('debugProps=', debugProps)

  const handleClickRateYourSamples = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_EMPTY_RATE_YOUR_SAMPLES)
  }
  const handleClickShopSamples = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_EMPTY_SHOP_SAMPLES)
  }

  const icon = (
    <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.00006 16.4582C7.84006 16.4582 7.68004 16.3973 7.55837 16.2748C7.3142 16.0307 7.3142 15.6348 7.55837 15.3906L12.95 9.999L7.55837 4.60736C7.3142 4.36319 7.3142 3.96733 7.55837 3.72316C7.80254 3.479 8.1984 3.479 8.44257 3.72316L14.2759 9.5565C14.5201 9.80066 14.5201 10.1965 14.2759 10.4407L8.44257 16.274C8.32007 16.3974 8.16006 16.4582 8.00006 16.4582Z' fill='#E15EC4' />
    </svg>
  )
  return (
    <Section className='squad-page-you-ve-rated-samples-across-orders-empty'>
      <H3>{TITLE}</H3>
      <Flex className='squad-page-you-ve-rated-samples-across-orders-empty-buttons'>
        <Link onClick={handleClickRateYourSamples} href={ROUTE_PATH.PS_SURVEY}>
          {RATE_YOUR_SAMPLES}
          {icon}
        </Link>
        <Link onClick={handleClickShopSamples} href={ROUTE_PATH.SAMPLE_COLLECTION}>
          {SHOP_SAMPLES}
          {icon}
        </Link>
      </Flex>
      <Flex className='squad-page-you-ve-rated-samples-across-orders-empty-buttons'>
        <Image src={IMAGE_URL} />
      </Flex>
    </Section>
  )
}
